export const CONVERSATION_TYPE = {
  DIRECT_MESSAGE: 'DIRECT_MESSAGE',
  BOOKING: 'BOOKING'
};

export const CONVERSATION_USER_ROLE = {
  COACH: 'COACH',
  CLIENT: 'CLIENT'
};
